'use strict';
const googleAttachmentMetaData = require('./google-attachment-metadata');
module.exports = function GoogleAttachmentPicker(googlePicker, authenticationModel) {
	const self = this,
		myContentType = 'application/vnd.google.drive.attachment';
	self.pickAttachment = function () {
		return authenticationModel.getProfile().then(function (userProfile) {
			return googlePicker.pickFile(userProfile, 'Select an attachment');
		}).then(function (item) {
			return {contentType: myContentType, content: googleAttachmentMetaData(item)};
		}).catch(function () {
			throw 'cancel';
		});
	};
};
